import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AlertService } from './alert.service';
import { AuthService } from './auth.service';
import { UserRole } from './user-role';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {
  constructor(private authService: AuthService,
    private alertService: AlertService) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isAuthorized(UserRole.FRANCHISEE)) {
      this.alertService.showWarningAlert('Admin Role Required');
      return false;
    }
    return true;
  }
}
